module.exports = __webpack_public_path__ + "da5ae36614e61cd298fc9df9f003174c.png";